export class Link {
    text;
    address;
    data;
    clickAction;
    key;
    constructor(text, address, data = null) {
        this.text = text;
        this.address = address;
        this.data = data;
    }
}
